import axios from "axios";
import { normalizeMediaUrls } from "@/lib/mediaUrl";

// Browser requests must always go through this app's own /api proxy route handler
// (src/app/api/[...path]/route.ts), which is the only place that knows the backend origin
// (API_INTERNAL_URL). Pointing the client at an absolute backend URL would bypass the proxy
// and expose the backend origin to the browser, so the base is hardcoded here.
export const API_PROXY_BASE = "/api";

export const http = axios.create({
    baseURL: API_PROXY_BASE,
    headers: {
        "Content-Type": "application/json",
    },
});

// Call sites pass backend paths that already start with "/api" (e.g. "/api/news-activities").
// Axios would naively join the two into "/api/api/...". Strip the duplicate prefix:
//   baseURL "/api" + "/api/news-activities" -> "/api/news-activities"
http.interceptors.request.use((config) => {
    const baseURL = config.baseURL ?? "";
    if (baseURL.replace(/\/+$/, "").endsWith("/api") && config.url?.startsWith("/api/")) {
        config.url = config.url.slice("/api".length);
    }
    return config;
});

http.interceptors.response.use((response) => {
    response.data = normalizeMediaUrls(response.data);
    return response;
});
